document.addEventListener('DOMContentLoaded', function () {
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileNavClose = document.querySelector('[data-mobile-nav-close]');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (mobileNavClose && mobileNav) {
    mobileNavClose.addEventListener('click', function () {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }
  if (mobileNav) {
    mobileNav.addEventListener('click', function (e) {
      if (e.target === mobileNav) {
        mobileNav.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    cartForm.querySelectorAll('input[type="number"]').forEach(function (input) {
      input.addEventListener('change', function () {
        cartForm.submit();
      });
    });
  }

  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var variantsScript = document.querySelector('[data-product-variants-json]');
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var optionSelects = Array.prototype.slice.call(
      productForm.querySelectorAll('[data-product-option]')
    );
    var variantIdInput = productForm.querySelector('[data-product-variant-id]');
    var priceEl = document.querySelector('[data-product-price]');
    var addToCartBtn = productForm.querySelector('[data-add-to-cart]');
    var unavailableNote = productForm.querySelector('[data-product-unavailable-note]');
    var mediaEl = document.querySelector('[data-product-media]');

    function getSelectedOptions() {
      var selected = [];
      optionSelects.forEach(function (select) {
        var index = parseInt(select.getAttribute('data-option-index'), 10);
        selected[index] = select.value;
      });
      return selected;
    }

    function findMatchingVariant(selectedOptions) {
      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        var matches = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (variant.options[j] !== selectedOptions[j]) {
            matches = false;
            break;
          }
        }
        if (matches) {
          return variant;
        }
      }
      return null;
    }

    function updateForVariant(variant) {
      if (!variant) {
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'Unavailable';
        }
        if (unavailableNote) {
          unavailableNote.style.display = 'block';
        }
        return;
      }

      if (variantIdInput) {
        variantIdInput.value = variant.id;
      }
      if (priceEl) {
        priceEl.textContent = variant.price;
      }
      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
        addToCartBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
      if (unavailableNote) {
        unavailableNote.style.display = variant.available ? 'none' : 'block';
      }
      if (mediaEl && variant.featured_image) {
        mediaEl.src = variant.featured_image;
      }
    }

    if (optionSelects.length > 0) {
      optionSelects.forEach(function (select) {
        select.addEventListener('change', function () {
          var selected = getSelectedOptions();
          var variant = findMatchingVariant(selected);
          updateForVariant(variant);
        });
      });
    }
  }
});
